import { connect } from "react-redux";
import { setSelectedTab } from "../../../store/details/slice";
import DetailView from "./DetailView";
import { State } from "../../../store/state";

const mapStateToProps = (state: State) => ({
  selectedTab: state.details.selectedTab
});

const mapDispatchToProps = {
  setSelectedTab
};

const DetailViewContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(DetailView);

export default DetailViewContainer;
